
export const attributes = {
	alertPopup: "data-alert-popup",
	alertPopupClose: "data-alert-popup-close",
	alertFieldForFilter: "data-jobalert-field-for-filter",
	filterMultiChoiceCounter: "data-filter-multichoice-counter",
	filterMultiChoice: "data-filter-multichoice",
	filterValue: "data-filter-value",
	filterValueReset: "data-filter-reset-target",
	filterToggle: "data-filter-toggle",
	filterShowCount: "data-filter-show-count",
	filterName: "data-filter-name",
	filterVacancyAttribute: "data-filter-vacancy-text",
	filterVacanciesAttribute: "data-filter-vacancies-text",
	filterListAttribute: "data-filter-list",
	filterGeoButton: "data-filter-geo-target",
	filterPopup: "data-filter-popup",
	filterPopupClose: "data-filter-popup-close",
	filterPopupBack: "data-filter-popup-back",
	filterPopupOpen: "data-filter-popup-open",
	filterPopupConfirm: "data-filter-popup-confirm",
	filterBadge: "data-filter-badge"
}
